"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIGN_UP_CONSTS = void 0;
exports.SIGN_UP_CONSTS = {
    InitialLandingPathMetadataKey: 'initialLandingPath',
    /**
     * Per-organization boolean map on Clerk `User.publicMetadata`. Holds the Clerk organization
     * ids the user was previously removed from (legacy users may still carry an array). The
     * `/routing` team-detection modal filters Clerk's `userSuggestions` against this list so a
     * removed member is never re-suggested to their old workspace. Server-writable only —
     * `publicMetadata` cannot be tampered with from the client.
     */
    RejectedOrganizationIdsMetadataKey: 'rejectedOrganizationIds',
    /**
     * Boolean key on Clerk `User.publicMetadata`, set when an admin rejects the user's request to
     * join their workspace (via our members UI → `POST /auth/reject-join-request`). Clerk removes
     * the suggestion on reject and exposes no "rejected" status to the requester, so this flag is
     * the signal `/routing` uses to show the one-time "Access request rejected" modal. The
     * dismissal endpoint clears it without removing rejected organization ids.
     */
    JoinRequestRejectedMetadataKey: 'joinRequestRejected',
    /**
     * Boolean flag stamped on Clerk user unsafe_metadata during signup when
     * the user is mid-Shopify-install (detected via `shopify_pending_shop`
     * in localStorage at the time the Clerk signup is created).
     *
     * The Clerk `user.created` webhook reads this flag and *skips* the
     * default org/brand/credit-pool seeding. The Shopify claim endpoint
     * (`POST /shopify/install/claim`) is the only path that finalizes
     * onboarding for these users — it either joins them to the existing
     * shop org (if a coworker already installed) or creates the org +
     * brand + subscription as a single transaction.
     *
     * Only a boolean — never the shop domain — because unsafe_metadata is
     * user-writable. Trusting the domain here would let any signup hijack
     * an existing shop org. Shop-binding is still proved by the App Bridge
     * session token at claim time.
     */
    ViaShopifyInstallMetadataKey: 'viaShopifyInstall',
    /**
     * The board owner's in-house referral code (`Organization.referralCode`), stamped on Clerk
     * user `unsafe_metadata` at signup when a signed-out visitor signs up from a public ad board.
     *
     * Attribution rides INSIDE the signup here — not on the separate, best-effort client tracking
     * POST, which races (and loses to) the signup navigation, especially Google OAuth, silently
     * dropping the referral. The `user.created` webhook reads this and stamps the `r`
     * OrganizationParameter on the new org, so the owner is credited on the referred org's first
     * paid subscription. Only the referral code (public, non-sensitive) is carried.
     */
    BoardReferralCodeMetadataKey: 'boardReferralCode',
    /**
     * The Dub affiliate click id (`dub_id`), stamped on Clerk `unsafe_metadata` at signup whenever
     * one was captured client-side — after traversing (or client-minting) any Dub referral link,
     * an affiliate board or a Dub marketing link alike, not board signups only. Carried INSIDE the
     * signup — same reliable rail as the referral code — so the `user.created` webhook registers the
     * Dub lead server-side (`DubService`) rather than the racy post-org client sync (that sync stays
     * as an idempotent backstop). Dub is click-anchored: this id only exists after a real click and
     * already encodes the partner, so the webhook needs nothing else to attribute. For a board
     * signup, the owner's enrolled program decides which credit applies — see
     * `resolveBoardSignupAttribution`.
     */
    DubClickIdMetadataKey: 'dubClickId',
};
